import React from "react";
import "../Footer/Footer.css";
import { BiSolidHome } from "react-icons/bi";
import { Link } from "react-router-dom";
import { IoCall } from "react-icons/io5";
import { MdEmail } from "react-icons/md";
import { FaFacebook } from "react-icons/fa";
import { RiInstagramFill } from "react-icons/ri";
import { FaSquareXTwitter } from "react-icons/fa6";
import { IoLogoWhatsapp } from "react-icons/io";
import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
  const calladmin = () => {
    window.location.href = 'tel:+919910171547';
  };
  

  return (
    <>
    <div class="custom-shape-divider-bottom-1717153105">
    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
        <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" class="shape-fill"></path>
    </svg>
</div>
      <footer>
      
        <div className="top_header">
          <section className="sec">
            <span>
              <BiSolidHome />
            </span>
            <Link to="/contact#map">
            <span>Sector 16b greater Noida west</span>
            </Link>
          </section>
          <section className="sec">
            <span>
            <IoCall />
            </span>
            <span onClick={calladmin}>9910171547</span>
          </section>
          <section className="sec">
            <span>
              <MdEmail />
            </span>
            <span><a className="mail-a" href="mailto:Info@thinkbuyproperty.com">Info@thinkbuyproperty.com</a></span>
          </section>
        </div>
        <div class="divider"><span></span><span>ThinkBuy Property</span><span></span></div>
        <div className="bottom_content">
          <section className="sec">
          <div className="sec-c">
          <a href="https://www.facebook.com/people/Think-buy-property/61561456803080/" target="_blank">
            <FaFacebook className="logo-c" />
          </a>
       
              <a className=" onclick-class" target='_blank'  href="https://www.instagram.com/think.buy.property/?igsh=eGJkZzBsZ2sxbnZr&utm_source=qr" role="button">
                 <RiInstagramFill className='logo-c'/>
                <div className="scan-image-container">
                  <img src="qrr.jpeg" alt="Scan Image" className="scan-image" />
                </div>
              </a>
           
         
          
          {/*
      <a href="#"><FaSquareXTwitter className='logo-c' /></a>
      <a href="#"><IoLogoWhatsapp className='logo-c' /></a>
      <a href="#"><FaLinkedin className='logo-c' /></a>
      */}
        </div>
            <Link to="/">Home</Link>
            <Link to="/about">About</Link>
            <Link to="/" >Exclusive Projects</Link>
            <Link to="/residential">Residential</Link>
             {/*
            <Link to="/client">Clients</Link>
             */}
            <Link to="/commercial">Commercial</Link>
            <Link to="/officespace">Plot</Link>
            <Link to="/contact">Contact</Link>

          </section>
        </div>
       
        <div className="copyright">
        Copyright © 2024 ThinkBuy Property - Powered by <a className="pow" href="https://infogainsoft.com/" target="_blank" rel="noopener noreferrer">Infogainsoft</a>
        </div>
      </footer>
    </>
  );
};

export default Footer;
